module.exports = __webpack_public_path__ + "img/1F1F9-1F1F2.7f39c85b.svg";